import { useParams } from "react-router-dom";
import QuestionCard from "../components/trends/question-card";
import TrendsHeader from "../components/trends/trends-header";
import { useGetTrendsDataQuery } from "../endpoints/trends.endpoints";
import { useState } from "react";
import { RefreshCw } from "lucide-react";

const TrendsTab: React.FC = () => {
  const { extSurveyId } = useParams<{ extSurveyId?: string }>();
  const { shareId } = useParams<{ shareId?: string }>();

  const surveyId = extSurveyId !== '' ? extSurveyId : shareId;
  const isShare = Boolean(shareId);
  const [selectedInterval, setSelectedInterval] = useState<number>(7);
  const [selectedDate, setSelectedDate] = useState<string>('last_week');
  const [selectedSurveyAnswers, setSelectedSurveyAnswers] = useState<string[]>([]);

  const { data: trendsData, isLoading: isLoadingTrendsData, isFetching: isFetchingTrendsData } = useGetTrendsDataQuery({ ext_survey_id: surveyId ?? '', share: isShare, interval: selectedInterval, selected_survey_answers: selectedSurveyAnswers });

  const handleAnswerClick = (answerId: string) => {
    if (selectedSurveyAnswers.includes(answerId)) {
      setSelectedSurveyAnswers(selectedSurveyAnswers.filter(id => id !== answerId));
    } else {
      setSelectedSurveyAnswers([...selectedSurveyAnswers, answerId]);
    }
  };

  const isLoading = isLoadingTrendsData || isFetchingTrendsData;

  return (
    <div className="relative pb-20" >
      {/* Loading Overlay */}
      {isLoading && (
        <div className="absolute -inset-5 bg-gray-200/80 backdrop-blur-sm z-50 flex items-center justify-center pointer-events-auto">
          <div className="flex flex-col items-center gap-4 p-4">
            <RefreshCw className="w-8 h-8 animate-spin text-blue-500" />
            <div className="text-center">
              <p className="text-lg font-semibold text-gray-800 mb-1">
                Loading Trends
              </p>
              <p className="text-sm text-gray-600">
                Fetching data...
              </p>
            </div>
          </div>
        </div>
      )}
      <TrendsHeader
        onIntervalChange={setSelectedInterval}
        onDateChange={setSelectedDate}
      />
      {Object.values(trendsData?.questions ?? {}).map((question, index) => (
        <div
          key={question.id}
          className={`${index > 0 ? 'mt-8' : 'mt-4'}`}
        >
          <div className="flex items-center mb-4">
            <div className="flex size-6 shrink-0 rounded-full bg-gray-500 items-center justify-center">
              <div className="text-white">
                {index + 1}
              </div>
            </div>
            <h4 className="text-2xl font-light text-gray-600 ml-4">
              {question.title}
            </h4>
          </div>

          <QuestionCard
            index={index}
            key={question.id}
            question={question}
            isLoading={isLoading}
            selectedDate={selectedDate}
            selectedInterval={selectedInterval}
            selectedSurveyAnswers={selectedSurveyAnswers}
            onAnswerClick={handleAnswerClick}
          />
        </div>
      ))}
    </div>
  );
};

export default TrendsTab;
